/* eslint-disable react/no-unescaped-entities */
import { Button } from "@components/Button";

import Head from "next/head";

import ViewerComponent from "@components/ViewerComponent";
import prisma from "@db/prisma";
import { useEffect, useState } from "react";
import { useAnalytics } from "@context/analytics";
import { buttonVariants } from "@utils/variants";
import { motion } from "framer-motion";
import { router } from "@server/trpc";
import { useRouter } from "next/router";
import { Logo } from "@components/Logo";
import { AnimatedTestimonials } from "@components/AnimatedTestimonials";
export default function Viewer({ post }: any) {
  const [showButton, setShowButton] = useState(false);
  const analytics = useAnalytics();
  useEffect(() => {
    if (window !== undefined) {
      analytics.page();
    }
    setTimeout(() => {
      setShowButton(true);
    }, 2000);

    return () => { };
  }, []);
  const router = useRouter();
  return (
    <>
      <div className="flex flex-row justify-between w-full p-4 bg-transparent fixed top-0 z-20 backdrop-blur-md">
        <Logo
          containerClassName="px-1 group "
          logoTextClassName="text-2xl text-black"
          svgClassName="h-10 w-10 transform text-black"
        />
        {showButton && (
          <motion.button
            variants={buttonVariants}
            onClick={() => {
              analytics.track("Viewer CTA Clicked");
              router.push("/");
            }}
            animate="show"
            initial="hidden"
            exit="exit"
            whileHover={{
              scale: 1.02,
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.98 }}
            className="hidden md:block bg-white px-4 py-2 rounded-md shadow text-zinc-700 font-semibold text-sm hover:shadow-xl transform hover:scale-105"
          >
            Make content like this in less than 5 minutes (free) 👀
          </motion.button>
        )}
      </div>
      <div className="container mx-auto max-w-5xl pt-20">
        <div className="prose prose-sm sm:prose lg:prose-lg xl:prose-xl m-5 focus:outline-none pb-10  px-4 sm:px-6 lg:px-8">
          <Head>
            <title>Moonbeam - {post?.title}</title>
            <meta
              name="description"
              content={`A preview of the post: ${post?.title}`}
            />
            {/* Open Graph */}
            <meta
              property="og:image"
              content={`https://app.gomoonbeam.com/api/og?title=${post?.title}`}
            />
            <meta property="og:title" content={`Moonbeam - ${post?.title}`} />
            <meta
              property="og:description"
              content={`A preview of the post: ${post?.title}`}
            />
            <meta
              property="og:url"
              content={`https://app.gomoonbeam.com/viewer/${post?.id}`}
            />
            <meta
              property="og:image"
              content={`https://app.gomoonbeam.com/api/og?title=${post?.title}`}
            />
            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@gomoonbeam" />
            <meta
              name="twitter:image"
              content={`https://app.gomoonbeam.com/api/og?title=${post?.title}`}
            />
            <meta name="twitter:title" content={`Moonbeam - ${post?.title}`} />
            <meta
              name="twitter:description"
              content={`A preview of the post: ${post?.title}`}
            />

            <meta property="og:image:type" content="image/png" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
          </Head>

          <ViewerComponent
            initJson={post?.content}
            binary={post?.binaryContent}
          />
          {showButton && (
            <div className="fixed md:hidden flex justify-center bottom-4 left-0 right-0">
              <motion.button
                variants={buttonVariants}
                onClick={() => {
                  analytics.track("Viewer CTA Clicked");
                  router.push("/");
                }}
                animate="show"
                initial="hidden"
                exit="exit"
                whileHover={{
                  scale: 1.02,
                  transition: { duration: 0.2 },
                }}
                whileTap={{ scale: 0.98 }}
                className="md:hidden bg-white px-4 py-2 mx-4 rounded-md shadow text-zinc-700 font-semibold text-sm hover:shadow-xl transform hover:scale-105"
              >
                Make content like this in less than 5 minutes (free) 👀
              </motion.button>
            </div>
          )}
        </div>
        {/* CHANGE COPY */}
        <div className="pb-40 w-full  grid grid-cols-1 md:grid-cols-2 px-4">
          <div>
            <h2 className="text-3xl font-bold mb-4 text-zinc-700">
              Moonbeam is helping thousands of content creators
            </h2>
            <p className="mb-6 text-zinc-500">
              Sign up for moonbeam to create content like this in MINUTES. Write
              blogs, essays, proposals and much more seamlessly!
            </p>
            <motion.button
              variants={buttonVariants}
              onClick={() => {
                analytics.track("Viewer CTA Clicked");
                router.push("/");
              }}
              animate="show"
              initial="hidden"
              exit="exit"
              whileHover={{
                scale: 1.02,
                transition: { duration: 0.2 },
              }}
              whileTap={{ scale: 0.98 }}
              className=" bg-gradient-to-r from-emerald-500 to-teal-600 px-4 py-2 rounded-md shadow text-white font-semibold text-sm hover:shadow-xl transform hover:scale-105"
            >
              Take me to Moonbeam
            </motion.button>
          </div>
          <AnimatedTestimonials className="flex " />
        </div>
      </div>
    </>
  );
}

export async function getStaticProps({ params }: any) {
  const id = params?.id as string;
  let post: any = await prisma.post.findFirst({
    where: {
      id: id,
      public: true,
    },
  });
  if (!post) {
    return {
      redirect: { destination: "/", permanent: false },
    };
  }

  if (post) {
    post.createdAt = post.createdAt.toString();
    post.updatedAt = post.updatedAt.toString();
  }
  return {
    props: {
      post,

      //   points,
    },
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  const posts = await prisma.post.findMany({
    where: {
      public: true,
    },
    select: {
      id: true,
    },
  });

  const paths = posts.map((post) => ({ params: { id: post.id } }));
  return { paths, fallback: "blocking" };
}
